import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, PenToolIcon, RulerIcon } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-12 sm:py-24 px-4 bg-surface relative overflow-hidden" data-id="element-286">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-accent/5 rounded-full blur-[100px] translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-287"></div>

      <div className="max-w-4xl mx-auto" data-id="element-288">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-289">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl mb-6 text-text" data-id="element-290">
            La elegancia no viene de la resina o el bronce... <br data-id="element-291" />
            <span className="text-accent italic" data-id="element-292">
              viene de la precisión geométrica.
            </span>
          </h2>
          <p className="text-lg text-textMuted leading-relaxed max-w-2xl mx-auto" data-id="element-293">
            Después de años de arruinar papel, desarrollé el método{' '}
            <strong className="text-text font-semibold" data-id="element-294">"Invisi-Glue"</strong> y
            el sistema de marcado{' '}
            <strong className="text-text font-semibold" data-id="element-295">"Score-Pro"</strong>.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-296">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-background p-8 rounded-2xl border border-white/5 relative overflow-hidden group" data-id="element-297">
            <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-298">
              <PenToolIcon className="w-24 h-24 text-accent" data-id="element-299" />
            </div>
            <h3 className="text-xl font-serif text-text mb-3 relative z-10" data-id="element-300">
              Lo que NO necesitas
            </h3>
            <ul className="space-y-3 text-textMuted relative z-10" data-id="element-301">
              <li className="flex items-center gap-2" data-id="element-302">
                <span className="text-danger" data-id="element-303">✕</span> Una Cricut de $300 USD
              </li>
              <li className="flex items-center gap-2" data-id="element-304">
                <span className="text-danger" data-id="element-305">✕</span> Materiales importados
              </li>
              <li className="flex items-center gap-2" data-id="element-306">
                <span className="text-danger" data-id="element-307">✕</span> Años de experiencia en
                arte
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-background p-8 rounded-2xl border border-accent/20 relative overflow-hidden group" data-id="element-308">
            <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-309">
              <RulerIcon className="w-24 h-24 text-accent" data-id="element-310" />
            </div>
            <h3 className="text-xl font-serif text-accent mb-3 relative z-10" data-id="element-311">
              Lo que SÍ necesitas
            </h3>
            <ul className="space-y-3 text-textMuted relative z-10" data-id="element-312">
              <li className="flex items-center gap-2" data-id="element-313">
                <span className="text-accent" data-id="element-314">✓</span> Una regla común
              </li>
              <li className="flex items-center gap-2" data-id="element-315">
                <span className="text-accent" data-id="element-316">✓</span> Un viejo bolígrafo sin
                tinta
              </li>
              <li className="flex items-center gap-2" data-id="element-317">
                <span className="text-accent" data-id="element-318">✓</span> Mi guía maestra
              </li>
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-12 text-center" data-id="element-319">
          <div className="inline-flex items-center gap-3 bg-accent/10 border border-accent/20 px-6 py-3 rounded-full text-accent font-medium" data-id="element-320">
            <SparklesIcon className="w-5 h-5" data-id="element-321" />
            Es meditación creativa con un resultado de lujo.
          </div>
        </motion.div>
      </div>
    </section>;
}